import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from '../../../Layout/Menu/Menu';
import { Navigation, NavigationMobile } from '../../Navigation/Menu';
import Table from "../../../Layout/Table/Table";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavBar from "../../../../components/NavBar";

const ListAccounts = () => {
    let params = useParams();
    const [data, setData] = useState([])


    const columns = ['', 'name', 'venue', 'status', 'Actions'];

    const serializeRowsColums = () => {
        return data.map((item) => {

            return {
                ...item,
            };
        })
    }


    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-sm-12 dashboard-content">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="dashboard-h2">Contas de Faturação</h2>
                            </div>
                            <div className="col-4 ">
                                <div className="btn btn-primary float-end" ><i className="fa-solid fa-plus"></i>&nbsp;Adicionar</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 event-list-table" >
                                <Table
                                    columns={columns}
                                    data={serializeRowsColums(data)}
                                    currentPage={1}
                                    itemsPerPage={10}
                                    totalItems={data.length}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </NavBar>
            {/* <ToastContainer /> */}
        </div>
    );
}

export default ListAccounts;